import { useState } from "react";
import { boards, type Board } from "@/mocks/communityData";

const boardStyles: Record<string, { bubble: string; hover: string; big: string }> = {
  primary: {
    bubble: "bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50",
    hover: "hover:ring-primary-300",
    big: "from-primary-500 to-primary-600",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50",
    hover: "hover:ring-secondary-300",
    big: "from-secondary-500 to-secondary-600",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-800 group-hover:bg-accent-500 group-hover:text-background-50",
    hover: "hover:ring-accent-300",
    big: "from-accent-500 to-accent-600",
  },
};

const filters = ["全部版块", "闲聊灌水", "热事吃瓜", "深度讨论"];

function matchFilter(board: Board, f: string) {
  if (f === "全部版块") return true;
  if (f === "闲聊灌水") return board.name === "灌水区";
  if (f === "热事吃瓜") return ["全网评论区", "吃瓜现场", "话题广场"].includes(board.name);
  return ["讨论版块", "爆料速递"].includes(board.name);
}

export default function Plaza() {
  const [filter, setFilter] = useState("全部版块");
  const visible = boards.filter((b) => matchFilter(b, filter));

  return (
    <section id="plaza" aria-label="话题广场与讨论版块" className="w-full bg-background-50 py-16 md:py-24">
      <div className="container-x">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="tag-primary"><i className="ri-discuss-line"></i>Community</span>
            <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              话题广场<span className="text-primary-500">任你逛</span>
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              从热事围观到轻松闲聊，六大版块各有主场。挑一个感兴趣的入口，今天也在线加入讨论。
            </p>
          </div>

          <div className="flex flex-wrap gap-1.5">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setFilter(f)}
                className={
                  "cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors " +
                  (filter === f
                    ? "bg-foreground-950 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200")
                }
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((b) => {
            const s = boardStyles[b.tone];
            return (
              <a
                key={b.id}
                href="#feed"
                aria-label={"进入版块：" + b.name}
                className={
                  "group relative cursor-pointer overflow-hidden rounded-2xl bg-background-50 p-6 ring-1 ring-background-200 transition-all duration-300 hover:-translate-y-1 hover:ring-2 " +
                  s.hover
                }
              >
                <span className={"pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-gradient-to-br opacity-10 transition-transform duration-500 group-hover:scale-150 " + s.big}></span>
                <span className={"flex h-12 w-12 items-center justify-center rounded-2xl text-2xl transition-colors duration-300 " + s.bubble}>
                  <i className={b.icon}></i>
                </span>
                <div className="mt-4 flex items-center gap-2">
                  <h3 className="text-lg font-black text-foreground-950">{b.name}</h3>
                  <i className="ri-arrow-right-up-line text-foreground-400 transition-all group-hover:text-primary-500"></i>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{b.desc}</p>
                <div className="mt-5 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-quill-pen-line"></i>{b.posts}</span>
                  <span className="flex items-center gap-1"><i className="ri-group-line"></i>{b.members} 瓜友</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}